<template>
    <div>
        <div v-if="stickyAddToCart" :class="[{ 'has-crossprice': hasCrossPrice }]" class="d-flex justify-content-start align-items-center">
            <span class="price mr-1" :class="{ 'is-special-offer': hasSpecialOffer }">
                <span class="font-weight-bolder">
                    <template v-if="showDynamicPrice">
                        {{ $translate("Ceres::Template.dynamicVariationPrice",
                            {
                                price: $options.filters.currency(variationTotalPrice, currentVariation.prices.default.currency)
                            }
                        ) }}
                    </template>

                    <template v-else>
                        <span>{{ currentVariation.prices.default.currency }}</span><!--
                        --><span class="mb-0">{{ variationTotalPrice | currency("") }}</span>
                    </template>
                </span>
            </span>
            <div class="crossprice" v-if="showCrossPrice && hasCrossPrice" :class="{ 'is-special-offer': hasSpecialOffer }">
                <del class="text-muted text-appearance">
                    <template v-if="hasSpecialOffer">
                        {{ currentVariation.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                    </template>
                    <template v-else>
                        {{ $translate("GonserDT::Template.itemUvp",
                            {
                            price: $options.filters.currency(currentVariation.prices.rrp.unitPrice.value, " ")
                            })
                        }}
                    </template>
                </del>
            </div>
        </div>
        <div v-else :class="[{ 'has-crossprice': hasCrossPrice }]">
            <div v-if="hasCrossPrice && currentVariation.prices.rrp && currentVariation.prices.rrp.unitPrice.value > 0 && currentVariation.prices.rrp.unitPrice.value > currentVariation.prices.default.unitPrice.value"
                class="text-danger font-weight-bold">
                <span v-if="hasSpecialOffer"><!--
                    -->{{ $translate("GonserDT::Template.itemYouSave",
                        {
                            value: Math.floor((currentVariation.prices.rrp.unitPrice.value - currentVariation.prices.specialOffer.unitPrice.value) / currentVariation.prices.rrp.unitPrice.value * 100)
                        })
                    }}
                </span>
                <span v-else><!--
                    -->{{ $translate("GonserDT::Template.itemYouSave",
                        {
                            value: Math.floor((currentVariation.prices.rrp.unitPrice.value-currentVariation.prices.default.unitPrice.value)/currentVariation.prices.rrp.unitPrice.value * 100)
                        })
                    }}
                </span>
            </div>
            <span class="price" :class="{ 'is-special-offer': hasSpecialOffer }">
                <span>
                    <template v-if="showDynamicPrice">
                        {{ $translate("Ceres::Template.dynamicVariationPrice",
                            {
                                price: $options.filters.currency(variationTotalPrice, currentVariation.prices.default.currency)
                            }
                        ) }}
                    </template>

                    <template v-else>
                        <span>{{ currentVariation.prices.default.currency }}</span><!--
                        --><span class="h1 text-danger font-weight-bolder mb-0 ml-n1">{{ variationTotalPrice | currency("") }}</span>
                    </template>
                </span>
            </span>
            <div class="crossprice" v-if="showCrossPrice && hasCrossPrice" :class="{ 'is-special-offer': hasSpecialOffer }">
                <del class="text-muted text-appearance">
                    <template v-if="hasSpecialOffer">
                        {{ currentVariation.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                    </template>
                    <template v-else>
                        {{ $translate("GonserDT::Template.itemUvp",
                            {
                            price: $options.filters.currency(currentVariation.prices.rrp.unitPrice.value, " ")
                            })
                        }}
                    </template>
                </del>
            </div>
        </div>
    </div>
    
</template>

<script>
import { hasVat } from "../../helper/OrderPropertyHelper";
export default {
    name: "item-price",

    props:
    {
        showCrossPrice:
        {
            type: Boolean,
            default: true
        },
        stickyAddToCart:
        {
            type: Boolean,
            default: false
        },
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
                this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

            const hasBeforePrice = this.hasSpecialOffer &&
                !!this.currentVariation.prices.default &&
                this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },

        hasSpecialOffer() {
            return !!this.currentVariation.prices.specialOffer;
        },

        variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
        },

        variationTotalPrice() {
            return this.$store.getters[`${this.itemId}/variationTotalPrice`];
        },

        showDynamicPrice() {
            const state = this.$store.state.items[this.itemId];
            return App.config.item.showPleaseSelect && App.isCheapestSorting
                && (state.variationSelect && !state.variationSelect.isVariationSelected)
                && (state.pleaseSelectVariationId === this.currentVariation.variation.id
                    || state.pleaseSelectVariationId === 0);
        },

        propertiesWithAdditionalCostsVisible() {
            return this.currentVariation.properties.filter(entry => {
                const property = entry.property;
                return property && property.isShownAsAdditionalCosts && property.isShownOnItemPage
                    && ((!property.isOderProperty && !App.useVariationOrderProperties)
                    || this.isVariationOrderPropertyRequiredPreselected(property))


            });
        }
    },
    methods: {
        isVariationOrderPropertyRequiredPreselected(property) {
            return property.isRequired
                    && property.isPreSelected
                    && property.isOderProperty
                    && App.useVariationOrderProperties
        },

        hasTax(property)
        {
            return hasVat(property);
        }
    }
}
</script>
